import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { FormApi } from 'final-form';

import { useActions } from '../../../../hooks/useActions';
import { modalStateSelector } from '../../../../store/redux-slices/modals/selectors';
import {
  SUBSCRIPTION_RENEWAL_ANALYSE_LOADING_PROCESSING,
  SUBSCRIPTION_RENEWAL_MEMBERSHIPS_SAVE_PROCESSING,
} from '../../../../store/redux-slices/processes/constants';
import { useProcessing } from '../../../../hooks/useProcessing';
import { updateModalState } from '../../../../store/redux-slices/modals';
import { ProductSubscriptionRenewPageParamsType } from '../../../../models/types/RoutePath';
import { SUBSCRIPTION_RENEW_ANALYSE_MODAL } from '../../../../styledComponents/Modals/SubscriptionAnalyseModal/subscriptionAnalyse.consts';
import { SubscriptionMembershipFormValues } from '../../../../styledComponents/Modals/SubscriptionAnalyseModal/subscriptionAnalyse.types';
import {
  loadSRSubscriptionRenewalAnalyse,
  sendSRSubscriptionRenewalMemberships,
} from '../../../../store/saga-slices/subscriptions/securityResponse';
import { srSubscriptionRenewalAnalyseSelector } from '../../../../store/redux-slices/subscriptions/securityResponse/selectors';
import {
  ILoadSRSubscriptionRenewalAnalysePayload,
  ISendSRSubscriptionRenewalMembershipsRequest,
} from '../../../../store/saga-slices/subscriptions/securityResponse/models';

export const useSRSubscriptionAnalyseModal = (
  onAnalyseSuccess?: () => void,
) => {
  const { organizationId, subscriptionId } =
    useParams<ProductSubscriptionRenewPageParamsType>();
  const UpdateModalState = useActions(updateModalState);

  const LoadSubscriptionRenewalAnalyse = useActions(
    loadSRSubscriptionRenewalAnalyse,
  );

  const SendSubscriptionRenewalMemberships = useActions(
    sendSRSubscriptionRenewalMemberships,
  );

  const isSubscriptionAnalyseLoading = useProcessing(
    SUBSCRIPTION_RENEWAL_ANALYSE_LOADING_PROCESSING,
  );

  const isSubscriptionMembershipInProgress = useProcessing(
    SUBSCRIPTION_RENEWAL_MEMBERSHIPS_SAVE_PROCESSING,
  );

  const isModalOpen = useSelector(
    modalStateSelector(SUBSCRIPTION_RENEW_ANALYSE_MODAL),
  );

  const subscriptionAnalyse = useSelector(srSubscriptionRenewalAnalyseSelector);

  useEffect(() => {
    const payload: ILoadSRSubscriptionRenewalAnalysePayload = {
      organizationId,
      subscriptionId,
    };

    isModalOpen && LoadSubscriptionRenewalAnalyse(payload);
  }, [
    LoadSubscriptionRenewalAnalyse,
    isModalOpen,
    organizationId,
    subscriptionId,
  ]);

  const handleSubmit = (
    values: SubscriptionMembershipFormValues,
    form: FormApi<any, any>,
  ) => {
    if (form.getState().invalid) {
      return;
    }

    const memberships = values.memberships.map(
      ({ membershipId, primaryMember, secondaryMembers }) => ({
        membershipId,
        members: [primaryMember, ...secondaryMembers].map(
          ({ memberId, toBeRenewed }) => ({ memberId, toBeRenewed }),
        ),
      }),
    );
    const payload: ISendSRSubscriptionRenewalMembershipsRequest = {
      organizationId,
      subscriptionId,
      data: { memberships },
      success: () => {
        onAnalyseSuccess && onAnalyseSuccess();
        UpdateModalState(SUBSCRIPTION_RENEW_ANALYSE_MODAL);
      },
    };

    SendSubscriptionRenewalMemberships(payload);
  };

  return {
    handleSubmit,
    initialValues: subscriptionAnalyse,
    totalMemberships: subscriptionAnalyse.totalMemberships,
    handleCancel: () => UpdateModalState(SUBSCRIPTION_RENEW_ANALYSE_MODAL),
    isSubscriptionAnalyseLoading,
    isSubscriptionMembershipInProgress,
  };
};
